import * as React from 'react';

export interface ReactSelectOptionData {
    id?: string,
    css?: string,
    style?: {},
    disabled?: boolean,
    disableID?: string,
    value?: string,
    text?: string,
    title?: string,
    row: any,
    dataKey: string,
}

export interface ReactSelectOptionState {
    disabled: boolean,
    row: any,
}

export class ReactSelectOption extends React.Component<ReactSelectOptionData> {
    constructor(props: ReactSelectOptionData) {
        super(props);
        this.state = {
            disabled: (props.disabled),
            row: (props.row),
        };

        // Binding is necessary to allow these functions access to the State data
        this.onDisableClick = this.onDisableClick.bind(this);
    }

    // Update the state externally
    componentWillReceiveProps(props: ReactSelectOptionData) {
        this.setState({
            disabled: props.disabled,
            row: props.row,
        });
    }

    onDisableClick(event: any) {
        const isChecked = $(event.currentTarget).is(":checked");
        this.setState({
            disabled: isChecked
        });
    }

    render() {
        if(this.props.title) {
            return <option selected={(this.state as ReactSelectOptionState).row[this.props.dataKey] == this.props.value} disabled={(this.state as ReactSelectOptionState).disabled} className={this.props.css} id={this.props.id} style={this.props.style} title={this.props.title} value={this.props.value}>{this.props.text}</option>;
        } else {
            return <option selected={(this.state as ReactSelectOptionState).row[this.props.dataKey] == this.props.value} disabled={(this.state as ReactSelectOptionState).disabled} className={this.props.css} id={this.props.id} style={this.props.style} value={this.props.value}>{this.props.text}</option>;
        }
    }
}
